import { useParams } from 'react-router-dom';
import Tutorial from '@Components/Tutorial';
import Manual from '@Components/Tutorial/Manual';
import VideoTutorial from '@Components/Tutorial/VideoTutorial';
import { cn } from '@Utils/index';

const TutorialPage = () => {
  const { tutorialType } = useParams();

  function getComponent() {
    switch (tutorialType) {
      case 'video-tutorial':
        return <VideoTutorial />;
      case 'manual':
        return <Manual />;
      default:
        return <Tutorial />;
    }
  }
  return (
    <div
      className={cn(
        'naxatw-h-full naxatw-bg-[#F4F7FE] md:naxatw-h-[calc(100vh-63px)] [@media_((max-height:42rem))]:naxatw-overflow-y-auto',
        !tutorialType && 'md:naxatw-overflow-y-hidden',
      )}
    >
      {getComponent()}
    </div>
  );
};

export default TutorialPage;
